/*
 * Copyright (c) 2020. Denis Rendler <connect@rendler.me>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';

const Quote = () => {
  return (
    <div className="text-center text-xl sm:text-2xl font-bold text-gray-500 md:w-10/12 lg:w-8/12 align-middle mx-auto capitalize my-4">
      <p>Keep sensitive information safe</p>
      <p className="text-sm sm:text-base">Use a secure sharing system</p>
    </div>
  );
};

export default Quote;
